// @ts-nocheck
import React from 'react';

const SIZES = { sm: 24, md: 32, lg: 44, xl: 60 };
const FONTS = { sm: 10, md: 12, lg: 14, xl: 18 };

const initialsOf = (name) => {
  if (!name) return '';
  return name.split(/\s+/).filter(Boolean).slice(0, 2).map(s => s[0]).join('').toUpperCase();
};

const Avatar = ({ name, src, size = 'md', className = '', tone = 'green' }) => {
  const px = typeof size === 'number' ? size : SIZES[size] || 32;
  const fz = typeof size === 'number' ? Math.max(10, Math.round(px * 0.4)) : FONTS[size] || 12;
  const toneCls = tone === 'green' ? 'mov-avatar-green' : 'mov-avatar-gray';
  return (
    <span
      className={`mov-avatar mov-avatar-base ${toneCls} ${className}`}
      style={{ width: px, height: px, fontSize: fz }}
    >
      {src
        ? <img src={src} alt={name || ''} className="mov-avatar-img" />
        : initialsOf(name)}
    </span>
  );
};

export const AvatarStack = ({ items = [], max = 4, size = 'sm' }) => {
  const shown = items.slice(0, max);
  const more = items.length - shown.length;
  const px = SIZES[size] || 24;
  return (
    <span className="inline-flex items-center">
      {shown.map((it, i) => (
        <span key={i} className={i === 0 ? 'mov-avatar-stack-ring' : 'mov-avatar-stack-ring -ml-2'}>
          <Avatar size={size} name={it.name} src={it.src} />
        </span>
      ))}
      {more > 0 && (
        <span
          className="mov-mono mov-avatar-stack-more"
          style={{ width: px, height: px }}
        >
          +{more}
        </span>
      )}
    </span>
  );
};

export default Avatar;
